import Home from "./Home";
import OneWrapper from "./one";

export const CollectorCollectsHome = Home;
export const CollectorCollectsOneWrapper = OneWrapper;
